module.exports = __webpack_public_path__ + "static/news-fallback-0bba20bab69b6acf1e7534cdcb98bdd9.png";